// Core
import styled from 'styled-components';

// Config
import { BREAKPOINTS } from '../../../../../../config/screen';

export const OverallStatusContainer = styled.div`
  min-width: 100%;
  display: flex;
  padding: 0.5rem 1rem;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
    border-bottom: none;
    border-right: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};
  };
`;

export const WinterModeStatusContainer = styled.div`
  display: flex;
  padding: 0.5rem 1rem;
  justify-content: space-between;
  align-items: center;
  border-right: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
    border-right: none;
  };
`;

export const CoolerFanStatusContainer = styled.div`
  width: 100%;
  display: flex;
  padding: 0.5rem 1rem;
  justify-content: space-between;
  align-items: center;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 1rem 1.5rem;
    border-left: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};
  };
`;

export const LubricationContainer = styled.div`
  background-color: ${({ theme }) => theme.color.crusherDashboard.modulesBackgroundColor};
  flex-direction: column;
  border-radius: 4px;
  display: flex;
  flex: 1;
  height: 100%;
`;

export const LubricationContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const LubePressureStatusContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
`;

export const ThermometersContainer = styled.div`
  border-right: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
`;

export const ReturnTempContainer = styled.div`
  padding: 0 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex: 1;
  box-sizing: border-box;
  border-right: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 0 1rem;
  };
`;

export const TankTempContainer = styled.div`
  padding: 0 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex: 1;
  box-sizing: border-box;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 0 1rem;
  };
`;

export const SupplyTempContainer = styled.div`
  border-left: 1px solid ${({ theme }) => theme.color.crusherDashboard.borderColor};
  padding: 0 0.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  flex: 1;
  box-sizing: border-box;

  @media (min-width: ${BREAKPOINTS.sm}px) {
    padding: 0 1rem;
  };
`;
